
import { getAgentId } from './index';

const FRAME_EVENT_CACHE_KEY = 'FRAME_EVENT_CACHE_KEY';
const FRAME_EVENT_CACHE_COUNT = 50;
export function frameEventHistory(): string[] {
  const cache = window.sessionStorage.getItem(FRAME_EVENT_CACHE_KEY);

  if (!cache) {
    return [];
  }

  const map: { [key: string]: string[] } = JSON.parse(cache);

  if (!map) {
    return [];
  }

  return map[getAgentId() || ''] || [];
}

export function addNewFrameEvent(h: string) {

  const cache = window.sessionStorage.getItem(FRAME_EVENT_CACHE_KEY);
  const map = JSON.parse(cache || '{}');
  const history = map[getAgentId() || ''] || [];
  const index = history.indexOf(h);

  if (index !== -1) {
    history.splice(index, 1);
  }

  history.unshift(h);

  while (history.length > FRAME_EVENT_CACHE_COUNT) {
    history.pop();
  }

  map[getAgentId() || ''] = history;
  window.sessionStorage.setItem(FRAME_EVENT_CACHE_KEY, JSON.stringify(map));
}
